__turbopack_context__.v({
  "container": "organization-signup-form-module-scss-module__LpRz2W__container",
  "signup-form-content": "organization-signup-form-module-scss-module__LpRz2W__signup-form-content",
  "signup-form-row": "organization-signup-form-module-scss-module__LpRz2W__signup-form-row",
  "signup-text": "organization-signup-form-module-scss-module__LpRz2W__signup-text",
  "subdomain-input-wrapper": "organization-signup-form-module-scss-module__LpRz2W__subdomain-input-wrapper",
  "subdomain-label-full": "organization-signup-form-module-scss-module__LpRz2W__subdomain-label-full",
  "subdomain-label-short": "organization-signup-form-module-scss-module__LpRz2W__subdomain-label-short",
  "subdomain-row": "organization-signup-form-module-scss-module__LpRz2W__subdomain-row",
  "subdomain-suffix": "organization-signup-form-module-scss-module__LpRz2W__subdomain-suffix",
  "submit-button-text": "organization-signup-form-module-scss-module__LpRz2W__submit-button-text",
  "submit-error": "organization-signup-form-module-scss-module__LpRz2W__submit-error",
});
